























// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Models
import {
  BudgetCommunicationStatus,
  BudgetPaymentStatus,
} from '@/manager/budget/models/budget.model';

// Components
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

// Constants
import Assets from '@/constants/assets.ts';

@Component({
  components: {
    Icon,
  },
  computed: {
    ...mapGetters({
      currentBudget: 'getCurrentBudgetAcceptance',
      budgetIsExpired: 'currentBudgetAcceptanceIsExpired',
    }),
  },
})
export default class InfoView extends Vue {
  private currentBudget!: any;
  private assets = Assets;
  private budgetIsExpired!: any;
  private iconEnum = IconEnum;
  private literals = {
    title: 'Ups!',
    subtitleExpired:
      'Parece que ha pasado demasiado tiempo y el alta al ' +
      'que quieres acceder ha caducado. Ponte en contacto con nosotros y te ayudaremos en lo que necesites. ',
    subtitleRejected:
      'Parece que el alta al que quieres acceder ha sido cancelado. ' +
      'Ponte en contacto con nosotros y te ayudaremos en lo que necesites.',
    subtitleAdjust:
      'Parece que el alta al que quieres acceder está pendiente de validación. ' +
      'Ponte en contacto con nosotros y te ayudaremos en lo que necesites.',
    subtitlePending:
      'Parece que el alta al que quieres acceder aún no está disponible. ' +
      'Ponte en contacto con nosotros y te ayudaremos en lo que necesites.',
    subtitleDispatched:
      'Parece que el alta al que quieres acceder no está pendiente de validación. ' +
      'Ponte en contacto con nosotros y te ayudaremos en lo que necesites.',
    supportEmail: 'info@levelupdesarollo.com',
    supportPhone: '965 20 20 20',
  };

  get backgroundImage() {
    return {
      'background-image': `url("${this.assets.acceptanceInfoBg}")`,
      'background-repeat': 'repeat-x',
      'background-size': 'contain',
      'background-position-y': 'bottom',
    };
  }

  get subtitle() {
    let subtitle = '';
    if (
      this.currentBudget.communicationStatus ===
        BudgetCommunicationStatus.Rejected ||
      this.currentBudget.paymentStatus === BudgetPaymentStatus.Cancelled
    ) {
      subtitle = this.literals.subtitleRejected;
    } else if (this.budgetIsExpired) {
      subtitle = this.literals.subtitleExpired;
    } else if (
      this.currentBudget.communicationStatus ===
      BudgetCommunicationStatus.Adjust
    ) {
      subtitle = this.literals.subtitleAdjust;
    } else if (
      this.currentBudget.communicationStatus ===
      BudgetCommunicationStatus.Pending
    ) {
      subtitle = this.literals.subtitlePending;
    }
    return subtitle;
  }

  private mailToLinkUrl() {
    window.location.href = `mailto:${this.literals.supportEmail}`;
  }
}
